import React from 'react'

function index() {
    return (
        <div>
            <h1>gallery</h1>
        </div>
    )
}

export default index
